import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "alegra-modal"
}
const _hoisted_2 = { class: "alegra-modal-content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "Felicitationes!", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("p", null, "El ganador es " + _toDisplayString(_ctx.winnerName) + "!", 1),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.proceed && _ctx.proceed(...args)))
          }, "Continuar")
        ])
      ]))
    : _createCommentVNode("", true)
}